import * as React from "react";

// eslint-disable-next-line no-restricted-imports
import type { AppMenuButtonProps } from "@1js/acui-button/lib/Next";

import { useRibbonMenuButtonStyles } from ".";
import { renderMenuButton_unstable } from "@fluentui/react-components";
import { useRibbonMenuButton } from "./useRibbonMenuButton";

export const RibbonMenuButton = React.memo(
  React.forwardRef<HTMLButtonElement, AppMenuButtonProps>((props, ref) => {
    const state = useRibbonMenuButton(props, ref);

    useRibbonMenuButtonStyles(state);

    return renderMenuButton_unstable(state);
  })
);

RibbonMenuButton.displayName = "next/RibbonMenuButton";
